import { render, staticRenderFns } from "./addToBucket.vue?vue&type=template&id=5d8cf04b&scoped=true&"
import script from "./addToBucket.vue?vue&type=script&lang=ts&"
export * from "./addToBucket.vue?vue&type=script&lang=ts&"
import style0 from "./addToBucket.css?vue&type=style&index=0&id=5d8cf04b&scoped=true&lang=css&"
import style1 from "./addToBucket1024.css?vue&type=style&index=1&id=5d8cf04b&scoped=true&lang=css&"
import style2 from "./addToBucket768.css?vue&type=style&index=2&id=5d8cf04b&scoped=true&lang=css&"
import style3 from "./addToBucket480.css?vue&type=style&index=3&id=5d8cf04b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8cf04b",
  null
  
)

export default component.exports